// import { RewardsEstimator} from './pages/RewardsEstimator'

import { createBrowserRouter } from 'react-router-dom';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { HomePage } from './pages/HomePage';
import AppSplashPage from './pages/AppSplashPage';
import AllCardsPage from './pages/AllCards';
import SignupBonuses from './pages/SignupBonuses';
import BrowseWallets from './pages/BrowseWallets';
import { NotFound } from './pages/NotFound';

const isDevelopment = process.env.NODE_ENV !== 'production';
const hostname = window.location.hostname;
const isAppSubdomain =
  hostname === 'app.cardclues.com' || hostname === 'app.localhost';

const mainRouter = createBrowserRouter([
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/cards',
    element: <HomePage />,
  },
  {
    path: '/w/:code',
    element: <HomePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  ...(isDevelopment
    ? [
        {
          path: '/all-cards',
          element: <AllCardsPage />,
        },
      ]
    : []),
  {
    path: '/signup-bonuses',
    element: <SignupBonuses />,
  },
  {
    path: '/browse-wallets',
    element: <BrowseWallets />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

const appRouter = createBrowserRouter([
  {
    path: '/',
    element: <AppSplashPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '*',
    element: <AppSplashPage />,
  },
]);

export const router = isAppSubdomain ? appRouter : mainRouter;
